/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import { useCallback, useRef } from "react";

export function usePreventDoubleSubmit(minIntervalMs = 1000) {
  const lastSubmitAtRef = useRef<number>(0);

  const canSubmit = useCallback(() => {
    const now = Date.now();
    return now - lastSubmitAtRef.current >= minIntervalMs;
  }, [minIntervalMs]);

  const markSubmitted = useCallback(() => {
    lastSubmitAtRef.current = Date.now();
  }, []);

  const guarded = useCallback(
    async <T>(fn: () => Promise<T> | T): Promise<T | undefined> => {
      if (!canSubmit()) return undefined;
      markSubmitted();
      return await fn();
    },
    [canSubmit, markSubmitted],
  );

  return { canSubmit, markSubmitted, guarded };
}
